import { Field, Textarea, VStack } from '@chakra-ui/react'
import type React from 'react'

export const NewClusterStep4Review: React.FC<{
  changelog: string
  onChange: (value: string) => void
}> = ({ changelog, onChange }) => {
  return (
    <VStack gap={6} alignItems="start" w="100%">
      <Field.Root w="100%">
        <Field.Label w={36}>Description</Field.Label>
        <Textarea
          placeholder="Please leave a comment"
          name="changeLog"
          id="changelog"
          value={changelog}
          onChange={(e) => onChange(e.target.value)}
        />
      </Field.Root>
    </VStack>
  )
}
